import { apolloClient } from 'App';
import { GET_SITE_CONSUMPTION_VARIATIONS_QUERY } from 'data/queries/consumptionVariation';
import { ConsumptionVariationFragmentFragment, GetSiteConsumptionVariationsQuery } from 'data/__generated__';

export const consumptionVariationsUpdatedOrCreatedHandler = (
    consumptionVariationsUpdatedOrCreated: ConsumptionVariationFragmentFragment[],
) => {
    let currentConsumptionVariations = [] as GetSiteConsumptionVariationsQuery['siteConsumptionVariations'];

    const result = apolloClient.readQuery<GetSiteConsumptionVariationsQuery>({
        query: GET_SITE_CONSUMPTION_VARIATIONS_QUERY,
        variables: { siteId: consumptionVariationsUpdatedOrCreated[0]?.siteId },
    });
    if (!result) {
        return;
    }
    currentConsumptionVariations = result.siteConsumptionVariations;

    const updatedOrCreatedConsumptionVariationIds = consumptionVariationsUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedConsumptionVariations = currentConsumptionVariations.filter(
        ({ _id }) => !updatedOrCreatedConsumptionVariationIds.includes(_id),
    );
    const newConsumptionVariations = [
        ...consumptionVariationsUpdatedOrCreated,
        ...nonUpdatedOrCreatedConsumptionVariations,
    ];

    apolloClient.writeQuery({
        query: GET_SITE_CONSUMPTION_VARIATIONS_QUERY,
        data: { siteConsumptionVariations: newConsumptionVariations },
        variables: { siteId: consumptionVariationsUpdatedOrCreated[0]?.siteId },
    });
};
